let keycloak = {
    url : '',
    realms : "Fi360-dev",
    clientId : "fi360",
    clientSecret: "Cc53IZkOC6Lsn6FRCDogKQzyK2CcrlQa",
    callbackUrl : "https://dev.fi360.fr/sso/call",
    scope : "openid profile email",
    keycloakUrl : ''
};

keycloak.url = 'https://sso.md-pro.fr/realms/' + keycloak.realms + '/protocol/openid-connect/auth?response_type=code&client_id=' + keycloak.clientId + '&redirect_uri=' + keycloak.callbackUrl + '&scope=' + keycloak.scope;
keycloak.keycloakUrl = 'https://sso.md-pro.fr/realms/' + keycloak.realms + '/protocol/openid-connect';


let config = {
    urlAPI : 'https://apidev.fi360.fr',
    urlAdmin : 'https://admindev.fi360.fr',
    activeworker : false,
    keycloak : keycloak
}

export default config




// WEBPACK FOOTER //
// ./src/js/config.js